import validator from 'validator';

const E_EMPTY_PLAN_LOT_SECTION = 'You must provide the address plan, lot or section details';
const E_EMPTY_CT = 'You must provide the address ct';

const isEmpty = (value) => validator.isEmpty(value, { ignore_whitespace: true });

export const validate = (values) => {
  var errors = {};

  if (isEmpty(values.address_plan_lot_section || '')) {
    errors.address_plan_lot_section = E_EMPTY_PLAN_LOT_SECTION;
  }

  if (isEmpty(values.address_ct || '')) {
    errors.address_ct = E_EMPTY_CT;
  }

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
